var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullEhr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 121,
    viewBox: "0 0 120 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 112.5H97C98.1046 112.5 99 111.605 99 110.5V54V33.5C99 32.3954 98.1046 31.5 97 31.5H35C33.8954 31.5 33 32.3954 33 33.5V110.5C33 111.605 33.8954 112.5 35 112.5Z",
    fill: "white",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 105.5H87C88.1046 105.5 89 104.605 89 103.5V45.5556V24.5C89 23.3954 88.1046 22.5 87 22.5H22C20.8954 22.5 20 23.3954 20 24.5V103.5C20 104.605 20.8954 105.5 22 105.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4988 44.1932V57.9308M61.8263 51.2146H47.0405M89 45.5556V103.5C89 104.605 88.1046 105.5 87 105.5H22C20.8954 105.5 20 104.605 20 103.5V24.5C20 23.3954 20.8954 22.5 22 22.5H87C88.1046 22.5 89 23.3954 89 24.5V45.5556Z",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9561 71.75H35",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9561 86.75H35",
    stroke: "#333333",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.391 17.375H77.3763V30.5H31V17.375H43.9854C43.9854 11.1618 48.5533 6.125 54.1882 6.125C59.823 6.125 64.391 11.1618 64.391 17.375Z",
    fill: "#D1EAFC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.391 17.375H62.391C62.391 18.4796 63.2864 19.375 64.391 19.375V17.375ZM77.3763 17.375H79.3763C79.3763 16.2704 78.4809 15.375 77.3763 15.375V17.375ZM77.3763 30.5V32.5C78.4809 32.5 79.3763 31.6046 79.3763 30.5H77.3763ZM31 30.5H29C29 31.6046 29.8954 32.5 31 32.5V30.5ZM31 17.375V15.375C29.8954 15.375 29 16.2704 29 17.375H31ZM43.9854 17.375V19.375C45.0899 19.375 45.9854 18.4796 45.9854 17.375H43.9854ZM64.391 19.375H77.3763V15.375H64.391V19.375ZM75.3763 17.375V30.5H79.3763V17.375H75.3763ZM77.3763 28.5H31V32.5H77.3763V28.5ZM33 30.5V17.375H29V30.5H33ZM31 19.375H43.9854V15.375H31V19.375ZM45.9854 17.375C45.9854 12.078 49.8373 8.125 54.1882 8.125V4.125C47.2694 4.125 41.9854 10.2456 41.9854 17.375H45.9854ZM54.1882 8.125C58.5391 8.125 62.391 12.078 62.391 17.375H66.391C66.391 10.2456 61.107 4.125 54.1882 4.125V8.125Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullEhr);
export default __webpack_public_path__ + "static/media/full-ehr.22f6463a.svg";
export { ForwardRef as ReactComponent };